import { LOAD_STATE } from '@shared/axios';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { buildDismissApiConfig } from './dismiss.api';

export const DISMISS_CARD = '@card/dismiss/DISMISS_CARD';

export const DISMISS_CARD_REQUEST_CALLED = '@card/dismiss/DISMISS_CARD_REQUEST_CALLED';
export const DISMISS_CARD_REQUEST_SUCCEEDED = '@card/dismiss/DISMISS_CARD_REQUEST_SUCCEEDED';
export const DISMISS_CARD_REQUEST_FAILED = '@card/dismiss/DISMISS_CARD_REQUEST_FAILED';

export const getDismissLoadState = state => state.cards.dismiss.loadState;

export const dismissCard = ({ cardId, days }) => ({
    type: DISMISS_CARD,
    payload: {
        cardId,
        days,
    },
});

export const dismissCardRequest = ({ cardId, days }) => ({
    type: DISMISS_CARD_REQUEST_CALLED,
    actionTypes: {
        success: DISMISS_CARD_REQUEST_SUCCEEDED,
        fail: DISMISS_CARD_REQUEST_FAILED,
    },
    config: buildDismissApiConfig({ cardId, days }),
});

const initialState = {
    loadState: LOAD_STATE.SUCCESS,
    error: null,
};

export const cardDismissReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [DISMISS_CARD_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [DISMISS_CARD_REQUEST_SUCCEEDED]: state => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
    }),
    [DISMISS_CARD_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload.response.data,
    }),
});
